import isEmpty from '@shared/utils/isEmpty';

export default function removeEmpty(object: { [key: string]: any }) {
  return Object.keys(object)
    .filter((key) => !isEmpty(object[key]))
    .reduce((values, key) => ({ ...values, [key]: object[key] }), {});
}
